import React from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../admin/AdminAuthContext";

const cards = [
  { title: "Job Applications",       description: "View and manage all hiring applicants",       icon: "👤", link: "/admin/hiring",          color: "#7c3aed" },
  { title: "Business Forms",         description: "Review submitted business intake forms",       icon: "🏢", link: "/admin/business-forms",   color: "#2563eb" },
  { title: "Software Forms",         description: "Browse software selection submissions",        icon: "💻", link: "/admin/software-forms",   color: "#059669" },
  { title: "Diagnostic Forms",       description: "Check diagnostic form submissions",            icon: "🔍", link: "/admin/diagnostic-forms", color: "#d97706" },
  { title: "Offer Form Submissions", description: "View $47 website offer signups",               icon: "💰", link: "/admin/offer-forms",      color: "#db2777" },
  { title: "Revival Submissions",    description: "View Reflex Revival™ $297/mo signups",        icon: "🔮", link: "/admin/revival-forms",    color: "#7b19bc" },
  { title: "Pricing Form Submissions", description: "View website pricing package signups",       icon: "💎", link: "/admin/pricing-forms",    color: "#0891b2" },

];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const { logout } = useAdminAuth();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.headerTop}>
          <div>
            <p style={s.label}>Admin Panel</p>
            <h1 style={s.title}>Dashboard</h1>
            <p style={s.sub}>Select a section to manage</p>
          </div>
          <button onClick={handleLogout} style={s.logoutBtn}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "6px" }}>
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            Logout
          </button>
        </div>
      </div>

      <div style={s.content}>
        <div style={s.grid}>
          {cards.map((card) => (
            <div
              key={card.link}
              style={s.card}
              onClick={() => navigate(card.link)}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = card.color;
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = `0 12px 32px ${card.color}22`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#e5e7eb";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 1px 2px rgba(0,0,0,0.04)";
              }}
            >
              <div style={{ ...s.iconBox, background: `${card.color}15` }}>
                <span style={s.icon}>{card.icon}</span>
              </div>
              <h2 style={s.cardTitle}>{card.title}</h2>
              <p style={s.cardDesc}>{card.description}</p>
              <div style={{ ...s.arrow, color: card.color }}>→</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { background: "#f7f7fa", minHeight: "100vh", color: "#0a0a0a", fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif" },
  header: { background: "#ffffff", padding: "60px 40px 40px", borderBottom: "1px solid #ece9f3" },
  headerTop: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", maxWidth: "900px", margin: "0 auto" },
  label: { fontSize: "12px", color: "#7b19bc", textTransform: "uppercase", letterSpacing: "3px", margin: "0 0 10px", fontWeight: 700 },
  title: { fontSize: "36px", fontWeight: 800, margin: "0 0 8px", color: "#0a0a0a" },
  sub: { fontSize: "15px", color: "#6b7280", margin: 0 },
  logoutBtn: {
    display: "flex", alignItems: "center",
    background: "#f7f7fa", border: "1px solid #e5e7eb",
    borderRadius: "8px", color: "#374151", fontSize: "13px", fontWeight: 500,
    padding: "8px 16px", cursor: "pointer", marginTop: "8px",
  },
  content: { maxWidth: "900px", margin: "0 auto", padding: "60px 20px" },
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "24px" },
  card: { background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "16px", padding: "32px", cursor: "pointer", transition: "border-color 0.2s, transform 0.2s, box-shadow 0.2s", boxShadow: "0 1px 2px rgba(0,0,0,0.04)" },
  iconBox: { width: "52px", height: "52px", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "20px" },
  icon: { fontSize: "24px" },
  cardTitle: { fontSize: "18px", fontWeight: 700, margin: "0 0 8px", color: "#0a0a0a" },
  cardDesc: { fontSize: "14px", color: "#6b7280", margin: "0 0 24px", lineHeight: "1.5" },
  arrow: { fontSize: "20px", fontWeight: 700 },
};